// extracted by mini-css-extract-plugin
module.exports = {"onlineTvListSlide":"OnlineTvList_onlineTvListSlide__Vsoij","sectionHeading":"OnlineTvList_sectionHeading__bHJqD","icon":"OnlineTvList_icon__zyFWl"};